import ReportHtml from './ReportHtml';
import microVisuals from './micro/visuals';

export default {
  chart: () => import('./ReportChart'),
  dashboard: () => import('./ReportDashboard'),
  decisionTree: () => import('./decisionTree/ReportDecisionTree'),
  embed: () => import('./ReportEmbed'),
  facet: () => import('./ReportFacet'),
  funnel: () => import('./ReportFunnel'),
  header: ReportHtml,
  html: ReportHtml,
  number: () => import('./ReportNumber'),
  percentage: () => import('./ReportNumber'),
  sentMessages: () => import('./ReportSentMessages'),
  table: () => import('./ReportTable'),
  ticker: () => import('./ReportTicker'),
  stat: microVisuals.stat,
  list: microVisuals.list,
  funnelTile: microVisuals.funnel,
  strip: microVisuals.strip,
  workflow: () => import('./ReportWorkflow'),
};
